import { render, staticRenderFns } from "./Home_Depan.vue?vue&type=template&id=7810b36d"
import script from "./Home_Depan.vue?vue&type=script&lang=js"
export * from "./Home_Depan.vue?vue&type=script&lang=js"
import style0 from "./Home_Depan.vue?vue&type=style&index=0&id=7810b36d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports